/* RESPONSIBLE TEAM: team-standalone */
import { default as StandaloneBaseWorkflowRoute } from 'embercom/routes/apps/app/standalone/channels/base-workflow';

export default class Route extends StandaloneBaseWorkflowRoute {}
